import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FeatureFlags, type FeatureFlagsType } from '../Config/growthbook';

const useGrowthBookFeature = (featureKey: FeatureFlags) => {
  const growthbook = useFeatureIsOn<FeatureFlagsType>(featureKey);

  return growthbook;
};

export default useGrowthBookFeature;
